import { configureStore } from "@reduxjs/toolkit";

import { alertSlice } from "./alertSlice";
import { aoiSlice } from "./aoiSlice";
import { dataSlice, filterDataMiddleware, mergeDataMiddleware } from "./dataSlice";
import { dataEditSlice } from "./dataEditSlice";
import { dataExplorerSlice } from "./dataExplorerSlice";
import { layerGroupSlice } from "./layerGroupSlice";
import { layerSlice } from "./layerSlice";
import { mapSlice } from "./mapSlice";
import { overlaySlice } from "./overlaySlice";
import { polygonSlice } from "./polygonSlice";
import { uiSlice } from "./uiSlice";

// redux devtools configuration to prevent excessive memory use
// see https://stackoverflow.com/questions/59826789/how-to-combine-state-sanitizer-with-existing-middleware-in-react-redux
// and https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/Troubleshooting.md#excessive-use-of-memory-and-cpu
const devToolsConfig = {
  stateSanitizer: (state) =>
    state.data ? { ...state, data: "<<LONG_BLOB>>" } : state,
};

const store = configureStore({
  reducer: {
    alert: alertSlice.reducer,
    aoi: aoiSlice.reducer,
    data: dataSlice.reducer,
    dataEdit: dataEditSlice.reducer,
    dataExplorer: dataExplorerSlice.reducer,
    layerGroup: layerGroupSlice.reducer,
    map: mapSlice.reducer,
    overlay: overlaySlice.reducer,
    layers: layerSlice.reducer,
    polygon: polygonSlice.reducer,
    ui: uiSlice.reducer,
  },
  // increase timeouts for serializable and immutable checks in dev mode
  // increase timeouts for serializable and immutable checks in dev mode
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: { warnAfter: 128 },
      serializableCheck: false,
    }).concat([mergeDataMiddleware, filterDataMiddleware]),
  devTools: devToolsConfig,
});

export const alertActions = alertSlice.actions;
export const aoiActions = aoiSlice.actions;
export const dataActions = dataSlice.actions;
export const dataEditActions = dataEditSlice.actions;
export const dataExplorerActions = dataExplorerSlice.actions;
export const layerGroupActions = layerGroupSlice.actions;
export const mapActions = mapSlice.actions;
export const overlayActions = overlaySlice.actions;
export const layerActions = layerSlice.actions;
export const polygonActions = polygonSlice.actions;
export const uiActions = uiSlice.actions;
export default store;
